import { useGetRedirectFromTyingTheKnot } from '@apps/createWedding/hooks';
import { useEffect } from 'react';
import { useTyingTheKnotHealth } from './TyingTheKnot.health';
import { useEventState } from '@apps/createWedding/EventState';
import { useAuth } from '@shared/components/AuthProvider';
import { useIsFirstDashboardVisit } from '@apps/admin/routes/Dashboard/hooks/useIsFirstDashboardVisit';

export const useTyingTheKnotController = () => {
  const { isLoggedIn, isCurrentUserSettled } = useAuth();

  const { isEventCreationSettled, createdEventData, createError } = useEventState();
  const { onLoadComplete } = useTyingTheKnotHealth();
  const redirectFunction = useGetRedirectFromTyingTheKnot();
  const website = createdEventData?.createEventV0301?.website;

  const { setFirstDashboardVisit } = useIsFirstDashboardVisit(createdEventData?.createEventV0301?.id);

  useEffect(() => {
    if (isCurrentUserSettled && isLoggedIn && isEventCreationSettled && website) {
      setFirstDashboardVisit(true);
      redirectFunction(website);
    }
  }, [website, isCurrentUserSettled, isEventCreationSettled, isLoggedIn, redirectFunction, setFirstDashboardVisit]);

  useEffect(() => {
    onLoadComplete();
  }, [onLoadComplete]);

  return { error: createError };
};
